export function roleLabelKey(role) {
  const code = typeof role === 'object' ? role.systemCode : role
  if (code === 'ADMIN') return 'administrator'
  if (code === 'MANAGER') return 'manager'
  if (code === 'SERVICE_SPECIALIST') return 'serviceSpecialist'
  if (code === 'OPERATOR') return 'operator'
  return null
}
